import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { PriceDisplay } from '@fielded/shared-ui'

const DueBalanceWidget = ({
  userData = {},
  isOnDark
}) => {
  const available = (userData.availableCashBalance || 0) + (userData.availableCreditBalance || 0)
  const due = userData.dueAmount || 0
  return (
    <aside className='due-balance-widget'>
      <span
        className={
          classnames(
            'due-balance-widget__badge',
            'due-balance-widget__badge--available',
            {'due-balance-widget__badge--dark': isOnDark}
          )
        }
      >
        <PriceDisplay
          value={available}
          currencySymbol
          currency={'ng'}
          scaleDecimal
          bold
        />
        Available
      </span>

      {!!due && (
        <span
          className={
            classnames(
              'due-balance-widget__badge',
              'due-balance-widget__badge--due',
              {'due-balance-widget__badge--dark': isOnDark}
            )
          }
        >
          <PriceDisplay
            value={due}
            currencySymbol
            currency={'ng'}
            scaleDecimal
            bold
          />
          Due
        </span>
      )}
    </aside>
  )
}

DueBalanceWidget.propTypes = {
  /**
   * User data as returned from the api for sales portal
   */
  userData: PropTypes.object.isRequired,
  /**
   * Version to be displayed on the top page banner (dark bg)
   */
  isOnDark: PropTypes.bool
}

export default DueBalanceWidget
